import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';

@Injectable({ providedIn: 'root' })
export class AuthorizationSchemeService {

    private createUrl = 'partners/authorization_scheme/create';
    private editUrl = 'partners/authorization_scheme/edit';
    private listUrl = 'partners/authorization_scheme/list';
    private getUrl = 'partners/authorization_scheme/get';

    constructor(private httpService: HttpService) { }

    create(partner: string, account: string, params) {
        return this.httpService.post(this.createUrl, params, partner, account);
    }

    edit(partner: string, account: string, params) {
        return this.httpService.post(this.editUrl, params, partner, account);
    }

    list(partner: string, account: string, loading = false) {
        return this.httpService.get(this.listUrl, partner, account, loading);
    }

    get(partner: string, account: string, authorization_scheme_id) {
        return this.httpService.post(this.getUrl, { authorization_scheme_id }, partner, account);
    }
}
